import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAppearance } from "@/lib/appearance";

export default function ThemeToggle() {
  const { prefs, setPrefs } = useAppearance();
  const isDark = prefs.themeMode === "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setPrefs({ themeMode: isDark ? "light" : "dark" })}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="button-theme-toggle"
    >
      {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </Button>
  );
}
